import { render, staticRenderFns } from "./ModalPreview.vue?vue&type=template&id=0886578c&"
import script from "./ModalPreview.vue?vue&type=script&lang=js&"
export * from "./ModalPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports